import React, { useState } from "react";
import {
  DeviceMeetingRemoteIcon,
  MingcuteFollowlineIcon,
} from "../common/Icon";
import FollowUpProfilePopUp from "../create-follow-popup/FollowUpProfilePopUp";
import MeetingProfileModal from "../create-follow-popup/MeetingProfileModal";
import ProfileCalendarPopUp from "../create-follow-popup/ProfileCalendarPopUp";

const SetDailyPlanModal = () => {
  const [profileFollowUpModal, setProfileFollowUpModal] = useState(false); // CREATE A FOLLOW UP PROFILE MODAL
  const [meetingFollowUpModal, setMeetingCreateFollowUpModal] = useState(false); // CREATE A FOLLOW UP PROFILE MODAL

  return (
    <>
      <div className="rounded-[22px] bg-white shadow-[0px_8px_20px_0px_rgba(0,_0,_0,_0.13)] w-[255px] py-6">
        <button
          onClick={() => setProfileFollowUpModal(true)}
          className="text-sm 3xl:text-[16px] text-black/70 font-normal  hover:bg-black/10  duration-200  py-[15px] pl-4 border-b-[1.393px] border-solid border-[#F2F2F2] flex items-center w-full">
          <span className="bg-primary rounded-full p-[6px] mr-3">
            <MingcuteFollowlineIcon />
          </span>
          Follow Up
        </button>
        <button
          onClick={() => setMeetingCreateFollowUpModal(true)}
          className="text-sm 3xl:text-[16px] text-black/70 font-normal  hover:bg-black/10  duration-200 py-[15px] pl-4 flex items-center w-full mt-1">
          <span className="bg-primary rounded-full p-[6px] mr-3">
            <DeviceMeetingRemoteIcon />
          </span>
          Meeting
        </button>
        <div className=" absolute top-[-200px] right-[-18px] xs:right-[-18px] xm:right-0  z-[9999]">
          {meetingFollowUpModal && <MeetingProfileModal />}
        </div>
        <div className=" absolute top-[-200px] right-[-18px] xs:right-[-18px] xm:right-0  z-[9999]">
          {profileFollowUpModal && <FollowUpProfilePopUp />}
        </div>
      </div>
    </>
  );
};

export default SetDailyPlanModal;
